import { http } from '~/lib/http'
import { FormSchemaAccount, FormSchemaChangePassword } from '~/schemas/account'
import { UploadAvatar, User } from '~/types/account'
import { Res } from '~/types/common'

const accountApi = {
    me() {
        return http.get<Res<User>>('/account/me')
    },
    deleteAvatar() {
        return http.delete<Res<null>>('/account/avatar')
    },
    uploadAvatar(data: UploadAvatar) {
        const form = new FormData()
        form.append('file', data.file)
        return http.post<Res<string>>('/account/avatar', form)
    },
    async profile() {
        return (await http.get<Res<User>>('/account/profile')).data
    },
    updateProfile(data: FormSchemaAccount) {
        return http.put<Res<User>>('/account/profile', data)
    },
    changePassword(data: FormSchemaChangePassword) {
        return http.put<Res<null>>('/account/change-password', data)
    }
}

export default accountApi
